import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectIsAuthenticated, selectAuthToken } from '../features/auth/authSlice';

const PrivateRoute = ({ children }) => {
  const authToken = sessionStorage.getItem("authToken");
  // const isAuthenticated =;
  const location = useLocation();

  // Check for authentication
  const isLoggedIn =  authToken;

  // If not authenticated, redirect to login page with the return url
  if (!isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If authenticated, render the children
  return children;
};

export default PrivateRoute;